/** @format */

import React from "react";
import { ReactComponent as Tag } from "bootstrap-icons/icons/tag-fill.svg";
import { ReactComponent as X } from "bootstrap-icons/icons/x.svg";
import { useTranslation } from "react-i18next";
import { QueryProps } from "../../resourceIndexUI/ResourcesIndexUI";
import { AllParams } from "../ResourcesFilter";

type Props = {
  isLoading?: boolean;
  ignoredTags: string[];
  query: QueryProps;
  allParams: AllParams; 
  handleQueryItemClick: (thisValue: string, thisQueryType: keyof QueryProps) => void;
};

const TagFilter: React.FC<Props> = ({ isLoading, ignoredTags, query, handleQueryItemClick, allParams }) => {
  const { t:_ } = useTranslation();

  let allTags = [...allParams.tags];

  return (
    <>
      {(!!allTags?.length || isLoading) && (
        <div className="card shadow mb-3" key="tags-filter">
          <div className="card-body">
            <h5>{_("Tags")}</h5>

            {isLoading &&
              Array(4)
                .fill(null)
                .map((u, i) => (
                  <button
                    key={`tag${i}`}
                    className={`btn rounded-pill p-0 me-2 text-decoration-none btn-link`}
                  >
                    <Tag />
                    &thinsp;
                    <span className="placeholder">
                      &emsp;&emsp;&emsp;{i % 2 === 0 && "&emsp;"}
                    </span>
                  </button>
                ))}

            {allTags?.sort().map(
              (_tag, index) =>
                !ignoredTags.includes(_tag.toLocaleLowerCase()) && (
                  <button
                    onClick={() => handleQueryItemClick(_tag, "tags")}
                    key={_tag + index}
                    className={`btn text-start rounded-pill p-0 me-2 text-decoration-none ${query.tags.includes(_tag) ? "btn-light" : "btn-link"}`}
                  >
                    {!query.tags.includes(_tag) ? <Tag /> : <X />}
                    &thinsp;{_tag}
                  </button>
                ),
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default TagFilter;
